import type { RoomDef } from '../../sim/types.ts';

/**
 * Room 2 — Rising (brief §6).
 *
 * Room 1 taught cast; this teaches that it works in mid-air. The floor itself
 * is gone for three columns (10 and 11 are both open there, not just row 9),
 * so there is nothing to stand on while crossing — the canonical solution
 * jumps out over the gap and casts a block ahead-and-below while still
 * airborne, landing on what it just built rather than on real ground. Miss
 * the timing and there is no floor left to catch you: you fall past the map
 * and the room fails on FailReason.Void, not FailReason.Chimera.
 *
 * SCAFFOLD CONTENT (brief §14, Sep 13-16), same as Room 1.
 *
 * Honesty note: nothing here mechanically forbids bridging the gap with flat,
 * same-row casts thrown from the solid edge before ever jumping - cast does
 * not require support under the target tile, so a grounded player can build a
 * walkway one tile at a time without leaving the ground. The recorded solution
 * does not do that; it demonstrates the air-cast the room is named for. Room 1
 * has the identical looseness (its wall can, in principle, be flanked other
 * ways too) and is labelled the same way.
 */
export const rising: RoomDef = {
  id: '02-rising',
  name: 'Rising',
  map: [
    '################',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '######...#######',
    '######...#######',
  ],
  spawn: { x: 3.5, y: 10 },
  portal: { tx: 14, ty: 9 },
  items: [
    // tx=5, not tx=3: at spawn (x=3.5) the player's hitbox already overlaps
    // tx=3, which auto-collects it on frame one before any input - found by
    // actually loading the room rather than trusting the simulation alone.
    { kind: 'lumen', tx: 5, ty: 9 },
    { kind: 'moonseed', tx: 10, ty: 9 },
  ],
  chimera: [],
};
